import React from 'react';
import TuvCertificateMessage from '@core/components/tuvcertificatemessage/TuvCertificateMessage';

import TuvImage from 'assets/images/pages/homepage/tuvcertificate.png';

import { Book1, Teacher, ShieldTick, Global } from 'iconsax-react';

import classes from './Certificate.module.scss';

const CERTIFICATE_URL = 'https://pharmuni.com/pharmuni-certificate/';

const HIGHLIGHTS = [
    {
        id: 'quality-assured',
        title: 'Quality-Assured',
        description: 'Every course is built within an ISO 9001-certified QMS.',
        Icon: ShieldTick,
    },
    {
        id: 'expert-led',
        title: 'Expert-Led',
        description: 'Content authored by practitioners with real pharmaceutical experience.',
        Icon: Teacher,
    },
    {
        id: 'industry-recognized',
        title: 'Industry-Recognized',
        description: 'Qualifications accepted across global pharma and biotech employers.',
        Icon: Global,
    },
    {
        id: 'practical-focused',
        title: 'Practical & Focused',
        description: 'Concise modules you can apply on the job from day one.',
        Icon: Book1,
    },
];

const Certificate = () => {
    return (
        <div className='container-fluid p-0'>
            <div className={classes['certificate-wrapper']}>
                <div className='container'>
                    <section className={classes['certificate']}>
                        <div className={classes['certificate__content']}>
                            <h3>What Makes Pharmuni Courses Different</h3>
                            <p>
                                All Pharmuni courses are developed under the ISO 9001-certified Quality Management System of
                                Zamann Pharma Support GmbH. This certification ensures our courses consistently meet strict
                                quality standards, giving you credible, industry-recognized qualifications.
                            </p>

                            <div className={classes['certificate__highlights']}>
                                {HIGHLIGHTS.map(({ id, title, description, Icon }) => (
                                    <div key={id} className={classes['certificate__highlight']}>
                                        <span className={classes['certificate__highlight-icon']}>
                                            <Icon size={27} color='#faa61a' />
                                        </span>
                                        <h4>{title}</h4>
                                        <p>{description}</p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className={classes['certificate__aside']}>
                            <a href={CERTIFICATE_URL} className={classes['certificate__image-wrapper']}>
                                <img
                                    src={TuvImage.src}
                                    alt='Pharmuni course certificate issued under the TÜV SÜD-certified ISO 9001 quality management system'
                                />
                            </a>
                            <TuvCertificateMessage /> 
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default Certificate;
